import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useNavigate } from 'libs/router'
import { queryKeys } from 'config/queryKeys'
import { routes } from 'config/routes'
import axios from 'libs/fetch'
import { FieldValues, UseFormSetError } from 'libs/form'
import { setApiFieldErrors } from 'utils/formErrors'

export const useAddProductMutation = (setError: UseFormSetError<FieldValues>) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()
	const navigate = useNavigate()

	const { mutate: addProductMutation, isPending: isAddProductLoading } = useMutation({
		mutationFn: ({ data }: { data: any; action: 'submit-redirect' | 'submit-stay' }) => {
			return axiosPrivate.post('/products/', data, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
		},
		onSuccess: (_, variables) => {
			const { action } = variables

			queryClient.invalidateQueries({ queryKey: queryKeys.products.all })
			useToast({
				type: 'success',
				message: t('Product added')
			})()

			if (action === 'submit-redirect') {
				navigate(routes.productIndex)
			} else if (action === 'submit-stay') {
				setTimeout(() => {
					navigate(0)
				}, 1000)
			}
		},
		onError: (error) => {
			if (axios.isAxiosError(error)) {
				if (error.response?.status === 400) setApiFieldErrors(setError, error.response.data)

				for (const [_key, value] of Object.entries(error?.response?.data)) {
					useToast({
						type: 'error',
						message: t(value as string)
					})()
				}

				return
			}
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		}
	})

	return {
		addProductMutation,
		isAddProductLoading
	}
}
